<ng-container *ngIf="vm$ | async as vm">
  <div class="cart flex--column flex--nowrap flex__child--auto flex--justify-space-between">
    <div class="wrapper--spacing-horizontal">
      <div class="flex flex--justify-space-between flex--align-end">
        <div class="spacing--margin-vertical" *ngIf="vm.location && vm.customer">
          <agr-location-summary [location]="vm.location" [customer]="vm.customer" [title]="'cart-title' | translate"></agr-location-summary>
        </div>

        <product-return-button class="spacing--padding-bottom" data-test="cart-overview__return-button"></product-return-button>
      </div>
      <div class="spacing--margin-bottom">
        <mat-divider></mat-divider>
        <app-customer-blocked-notification *ngIf="vm.location?.orderBlock"></app-customer-blocked-notification>
        <app-search *ngIf="vm.carts?.length === 0 && !vm.location?.orderBlock" [showAddProductsReminder]="true"></app-search>
      </div>
      <div>
        <agr-notification-status-message></agr-notification-status-message>
      </div>

      <app-delivery-date-weekend-warning></app-delivery-date-weekend-warning>

      <div class="spacing--margin-bottom">
        <div *ngIf="vm.aboutToExpire" class="notification notification-info text--input-small" data-test="cart-overview__identification-about-to-expire">
          <mat-icon>info</mat-icon>
          <div [innerHTML]="'cart-overview.identification-about-to-expire' | translate | replaceLinkInTranslation: linkToIdentification : false"></div>
        </div>
        <div *ngIf="vm.isExpired" class="notification notification-warning text--input-small" data-test="cart-overview__identification-expired">
          <mat-icon>warning</mat-icon>
          <div [innerHTML]="'cart-overview.identification-expired' | translate | replaceLinkInTranslation: linkToIdentification : false"></div>
        </div>
      </div>

      <div class="spacing--margin-top">
        <app-cart
          *ngFor="let cart of vm.carts; trackBy: trackById"
          [cart]="cart"
          [editable]="true"
          [extendAccordionMobile]="true"
          [id]="'cart-' + cart.id"
        ></app-cart>

        <agr-notification-empty [isEmpty]="vm.carts?.length === 0" [emptyTitle]="'cart-overview.empty-title' | translate" [emptyDescription]="">
        </agr-notification-empty>
      </div>
    </div>

    <div
      class="layout--padding-horizontal spacing--padding-vertical flex--justify-space-between flex--align-center flex--nowrap background-color--white border-top--gray4"
    >
      <a mat-button [routerLink]="['/shop']" data-test="cart-overview__continue-shopping">
        <mat-icon>arrow_back</mat-icon>
        {{ 'cart-overview.continue-shopping' | translate }}
      </a>
    </div>
  </div>
</ng-container>
